import {RootState} from '../../store';
import {Offer} from './types';

export const selectionSelector = (state: RootState): Record<string, Offer> =>
    state['offers'].selection;
